import { getUserDevice } from '@web-platform/shared-universal-redux/src/state';
import {
  getPlatform,
  type PLATFORM,
} from '@web-platform/shared-universal-utils-frontend/src/helpers/getPlatform';
import { useSelector } from 'react-redux';

/**
 *
 * @returns {'MWeb' | 'Tablet' | 'Desktop'} Enums used within Banana codebase to represent the type of platform
 */
export const usePlatform = (): (typeof PLATFORM)[keyof typeof PLATFORM] => {
  const device = useSelector(getUserDevice);

  return getPlatform(device);
};
